import { createSlice } from '@reduxjs/toolkit';

const LOCAL_STORAGE_KEY = "permissions";

// Load initial state from local storage
const loadPermissionsFromStorage = () => {
    const storedPermissions = localStorage.getItem(LOCAL_STORAGE_KEY);
    return storedPermissions ? JSON.parse(storedPermissions) : [];
};

const initialState = {
    permissions: loadPermissionsFromStorage(),
};

const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        setPermissions: (state, action) => {
            state.permissions = action.payload;
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.permissions)); // Save to local storage
        },
        addPermission: (state, action) => {
            const permission = action.payload;
            if (!state.permissions.includes(permission)) {
                state.permissions.push(permission);
                localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.permissions)); // Save updated permissions
            }
        },
        removePermission: (state, action) => {
            const permission = action.payload;
            state.permissions = state.permissions.filter(perm => perm !== permission);
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.permissions)); // Save updated permissions
        },
        clearPermissions: (state) => {
            state.permissions = [];
            localStorage.removeItem(LOCAL_STORAGE_KEY); // Remove from local storage
        },
    },
});

export const { setPermissions, addPermission, removePermission, clearPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
